import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Trophy } from "lucide-react";
import { api } from "@/lib/api";

let cache = null;
let pending = null;

const loadWinners = () => {
  if (cache) return Promise.resolve(cache);
  if (!pending) {
    pending = api.get("/awards/winners")
      .then((r) => { cache = r.data && typeof r.data === "object" ? r.data : {}; return cache; })
      .catch(() => { pending = null; return {}; });
  }
  return pending;
};

export function useAwards(companyId) {
  const [awards, setAwards] = useState([]);
  useEffect(() => {
    if (!companyId) return undefined;
    let live = true;
    loadWinners().then((m) => { if (live) setAwards(Array.isArray(m[companyId]) ? m[companyId] : []); });
    return () => { live = false; };
  }, [companyId]);
  return awards;
}

const slug = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-");

export function WinnerBadge({ award, size = "md", testid }) {
  const sm = size === "sm";
  const cls = `group inline-flex items-center gap-2 rounded-full bg-gradient-to-r from-[#8E2BC4] via-[#E0218A] to-[#B5157A] text-white font-semibold shadow-[0_0_24px_rgba(224,33,138,0.35)] hover:shadow-[0_0_36px_rgba(224,33,138,0.55)] transition-shadow ${sm ? "px-2.5 py-1 text-[10px]" : "px-4 py-1.5 text-xs"}`;
  const title = `${award.category} · Balqis Partners Awards ${award.year}`;
  const body = (
    <>
      <Trophy className={sm ? "h-3 w-3" : "h-3.5 w-3.5"} />
      <span className="uppercase tracking-[0.08em]">{sm ? `Award winner ${award.year}` : `${award.category} · ${award.year}`}</span>
    </>
  );
  if (sm) return <span title={title} className={cls} data-testid={testid}>{body}</span>;
  return (
    <Link to={`/awards/${award.year}/ceremony#${slug(award.category)}`} title={title} className={cls} data-testid={testid}>{body}</Link>
  );
}

export function WinnerBadges({ companyId, size = "md", max = 3, testid = "winner-badges" }) {
  const awards = useAwards(companyId);
  if (!awards.length) return null;
  const list = size === "sm" ? awards.slice(0, 1) : awards.slice(0, max);
  return (
    <div className="flex flex-wrap gap-2" data-testid={testid}>
      {list.map((a, i) => <WinnerBadge key={`${a.year}-${a.category}`} award={a} size={size} testid={`${testid}-${i}`} />)}
    </div>
  );
}
